import { render } from "./StageDynamicBudget.vue?vue&type=template&id=05b76cf5&scoped=true"
import script from "./StageDynamicBudget.vue?vue&type=script&lang=js"
export * from "./StageDynamicBudget.vue?vue&type=script&lang=js"

import "./StageDynamicBudget.vue?vue&type=style&index=0&id=05b76cf5&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b76cf5"]])

export default __exports__